export const pages = ["Home"];
export const links = ["/"];
